"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputOptionType = void 0;
var InputOptionType;
(function (InputOptionType) {
    InputOptionType[InputOptionType["TEXT"] = 0] = "TEXT";
    InputOptionType[InputOptionType["TEXT_FIELD"] = 1] = "TEXT_FIELD";
    InputOptionType[InputOptionType["NUMBER"] = 2] = "NUMBER";
    InputOptionType[InputOptionType["PASSWORD"] = 3] = "PASSWORD";
    InputOptionType[InputOptionType["DROPDOWN"] = 4] = "DROPDOWN";
    InputOptionType[InputOptionType["DATE"] = 5] = "DATE";
    InputOptionType[InputOptionType["TIME"] = 6] = "TIME";
    InputOptionType[InputOptionType["DATE_TIME"] = 7] = "DATE_TIME";
    InputOptionType[InputOptionType["COLOR"] = 8] = "COLOR";
    InputOptionType[InputOptionType["RANGE"] = 9] = "RANGE";
    InputOptionType[InputOptionType["CHECKBOX"] = 10] = "CHECKBOX";
    InputOptionType[InputOptionType["FILE"] = 11] = "FILE";
    InputOptionType[InputOptionType["CUSTOM"] = 12] = "CUSTOM";
    InputOptionType[InputOptionType["TAG_SELECTOR"] = 13] = "TAG_SELECTOR";
    InputOptionType[InputOptionType["USER_SELECTOR"] = 14] = "USER_SELECTOR";
    InputOptionType[InputOptionType["ICON"] = 15] = "ICON";
    InputOptionType[InputOptionType["ICON_TEXT"] = 16] = "ICON_TEXT";
    InputOptionType[InputOptionType["CONTENT_SWITCH"] = 17] = "CONTENT_SWITCH";
})(InputOptionType || (exports.InputOptionType = InputOptionType = {}));
